import React from 'react';

function WhoIsItFor() {
  return (
    <section className="py-16 md:py-20 lg:py-28 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl mb-4 md:mb-6 font-bold text-primary">Built Specifically For...</h2>
        <p className="max-w-3xl mx-auto mb-6 md:mb-8 text-primary-light">Freelancers, contractors, consultants, and micro-service businesses (1-5 people) who want a dead-simple way to automate payment reminders without switching from their current manual invoicing process.</p>
        <p className="text-lg md:text-xl text-primary font-medium max-w-3xl mx-auto">If you hate chasing payments but don't need a full accounting suite, this is for you.</p>
        <div className="mt-8 md:mt-10 max-w-3xl mx-auto px-4">
          <div className="p-4 md:p-5 bg-gray-50 text-primary-light text-sm border border-gray-100 rounded-lg">
            <span className="font-semibold text-primary block mb-1">Best for freelancers using manual invoicing (PDFs, Word, Email).</span>
            <span className="text-primary-light">Already using FreshBooks, Wave, QuickBooks? Our bot still works — if you prefer simple, flexible reminders.</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhoIsItFor; 